/* eslint-disable max-lines */
import Vue from 'vue';
import VCalendar from 'v-calendar';
import VJsoneditor from 'v-jsoneditor/src/index';
import BootstrapVueTreeview from 'bootstrap-vue-treeview';

Vue.use(VCalendar);
Vue.use(VJsoneditor);
Vue.use(BootstrapVueTreeview);

// ---------------------------------------------------------------------------
// Register other components, they start with 'v-', example: v-select
// ---------------------------------------------------------------------------
Vue.component('v-select', () =>
  import(/* webpackChunkName: "components/vendors/vue-select" */ 'vue-select')
);
Vue.component('vue-input-tag', () =>
  import(/* webpackChunkName: "components/vendors/vue-input-tag" */ 'vue-input-tag')
);
Vue.component('vue-slider', () =>
  import(/* webpackChunkName: "components/vendors/vue-slider" */ 'vue-slider-component')
);
// ---------------------------------------------------------------------------
// Register bootstrap-vue components, they start with 'b-', example: b-button
// ---------------------------------------------------------------------------
Vue.component('b-alert', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/alert" */ 'bootstrap-vue').then(
    ({ BAlert }) => BAlert
  )
);
Vue.component('b-badge', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/badge" */ 'bootstrap-vue').then(
    ({ BBadge }) => BBadge
  )
);
Vue.component('b-button', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/button" */ 'bootstrap-vue').then(
    ({ BButton }) => BButton
  )
);
Vue.component('b-button-group', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/button-group" */ 'bootstrap-vue').then(
    ({ BButtonGroup }) => BButtonGroup
  )
);
Vue.component('b-card', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/card/card" */ 'bootstrap-vue').then(
    ({ BCard }) => BCard
  )
);
Vue.component('b-card-header', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/card/card-header" */ 'bootstrap-vue').then(
    ({ BCardHeader }) => BCardHeader
  )
);
Vue.component('b-card-body', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/card/card-body" */ 'bootstrap-vue').then(
    ({ BCardBody }) => BCardBody
  )
);
Vue.component('b-card-footer', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/card/card-footer" */ 'bootstrap-vue').then(
    ({ BCardFooter }) => BCardFooter
  )
);
Vue.component('b-card-group', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/card/card-group" */ 'bootstrap-vue').then(
    ({ BCardGroup }) => BCardGroup
  )
);
Vue.component('b-col', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/layout/col" */ 'bootstrap-vue').then(
    ({ BCol }) => BCol
  )
);
Vue.component('b-container', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/layout/container" */ 'bootstrap-vue').then(
    ({ BContainer }) => BContainer
  )
);
Vue.component('b-dropdown-divider', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/dropdown/dropdown-divider" */ 'bootstrap-vue'
  ).then(({ BDropdownDivider }) => BDropdownDivider)
);
Vue.component('b-dropdown-header', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/dropdown/dropdown-header" */ 'bootstrap-vue'
  ).then(({ BDropdownHeader }) => BDropdownHeader)
);
Vue.component('b-dropdown-item', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/dropdown/dropdown-item" */ 'bootstrap-vue'
  ).then(({ BDropdownItem }) => BDropdownItem)
);
Vue.component('b-dropdown', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/dropdown/dropdown" */ 'bootstrap-vue').then(
    ({ BDropdown }) => BDropdown
  )
);
Vue.component('b-form', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/form/form" */ 'bootstrap-vue').then(
    ({ BForm }) => BForm
  )
);
Vue.component('b-form-checkbox', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/form-checkbox/form-checkbox" */ 'bootstrap-vue'
  ).then(({ BFormCheckbox }) => BFormCheckbox)
);
Vue.component('b-form-group', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/form-group" */ 'bootstrap-vue').then(
    ({ BFormGroup }) => BFormGroup
  )
);
Vue.component('b-form-input', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/form-input" */ 'bootstrap-vue').then(
    ({ BFormInput }) => BFormInput
  )
);
Vue.component('b-form-row', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/layout/form-row" */ 'bootstrap-vue').then(
    ({ BFormRow }) => BFormRow
  )
);
Vue.component('b-form-select', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/form-select" */ 'bootstrap-vue').then(
    ({ BFormSelect }) => BFormSelect
  )
);
Vue.component('b-form-text', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/form-textarea" */ 'bootstrap-vue').then(
    ({ BFormText }) => BFormText
  )
);
Vue.component('b-form-textarea', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/form-textarea" */ 'bootstrap-vue').then(
    ({ BFormTextarea }) => BFormTextarea
  )
);
Vue.component('b-img', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/image/img" */ 'bootstrap-vue').then(
    ({ BImg }) => BImg
  )
);
Vue.component('b-img-lazy', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/image/img-lazy" */ 'bootstrap-vue').then(
    ({ BImgLazy }) => BImgLazy
  )
);
Vue.component('b-input-group', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/input-group/input-group" */ 'bootstrap-vue'
  ).then(({ BInputGroup }) => BInputGroup)
);
Vue.component('b-input-group-append', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/input-group/input-group-append" */ 'bootstrap-vue'
  ).then(({ BInputGroupAppend }) => BInputGroupAppend)
);
Vue.component('b-input-group-prepend', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/input-group/input-group-prepend" */ 'bootstrap-vue'
  ).then(({ BInputGroupPrepend }) => BInputGroupPrepend)
);
Vue.component('b-input-group-text', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/input-group/input-group-text" */ 'bootstrap-vue'
  ).then(({ BInputGroupText }) => BInputGroupText)
);
Vue.component('b-link', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/link" */ 'bootstrap-vue').then(
    ({ BLink }) => BLink
  )
);
Vue.component('b-modal', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/modal" */ 'bootstrap-vue').then(
    ({ BModal }) => BModal
  )
);
Vue.component('b-nav-item', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/nav/nav-item" */ 'bootstrap-vue').then(
    ({ BNavItem }) => BNavItem
  )
);
Vue.component('b-nav-item-dropdown', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/nav/nav-item-dropdown" */ 'bootstrap-vue'
  ).then(({ BNavItemDropdown }) => BNavItemDropdown)
);
Vue.component('b-navbar-nav', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/navbar/navbar-nav" */ 'bootstrap-vue').then(
    ({ BNavbarNav }) => BNavbarNav
  )
);
Vue.component('b-pagination', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/pagination" */ 'bootstrap-vue').then(
    ({ BPagination }) => BPagination
  )
);
Vue.component('b-progress', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/progress" */ 'bootstrap-vue').then(
    ({ BProgress }) => BProgress
  )
);
Vue.component('b-row', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/layout/row" */ 'bootstrap-vue').then(
    ({ BRow }) => BRow
  )
);
// See documentation: https://bootstrap-vue.js.org/docs/components/table
Vue.component('b-table', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/table" */ 'bootstrap-vue').then(
    ({ BTable }) => BTable
  )
);
Vue.component('b-tab', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/tabs/tab" */ 'bootstrap-vue').then(
    ({ BTab }) => BTab
  )
);
Vue.component('b-tabs', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/tabs/tabs" */ 'bootstrap-vue').then(
    ({ BTabs }) => BTabs
  )
);
Vue.component('b-list-group', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/list-group/list-group" */ 'bootstrap-vue'
  ).then(({ BListGroup }) => BListGroup)
);
Vue.component('b-list-group-item', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/list-group/list-group-item" */ 'bootstrap-vue'
  ).then(({ BListGroupItem }) => BListGroupItem)
);
Vue.component('b-form-radio-group', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/list-group/form-radio-group" */ 'bootstrap-vue'
  ).then(({ BFormRadioGroup }) => BFormRadioGroup)
);
Vue.component('b-form-radio', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/list-group/form-radio" */ 'bootstrap-vue'
  ).then(({ BFormRadio }) => BFormRadio)
);
Vue.component('b-popover', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/popover/popover" */ 'bootstrap-vue').then(
    ({ BPopover }) => BPopover
  )
);
Vue.component('b-form-tags', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/tags/tags" */ 'bootstrap-vue').then(
    ({ BFormTags }) => BFormTags
  )
);
Vue.component('b-form-tag', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/tag/tag" */ 'bootstrap-vue').then(
    ({ BFormTag }) => BFormTag
  )
);
// -----------------------------------------------------------------------------------
// Register Ald Automotive components, they start with 'ald-', example: ald-accordion
// -----------------------------------------------------------------------------------
Vue.component('ald-accordion', () =>
  import(/* webpackChunkName: "components/ald/ald-accordion" */ 'components/Tesla/Accordion')
);
Vue.component('ald-alert-stratos', () =>
  import(/* webpackChunkName: "components/ald/ald-alert-stratos" */ 'components/Stratos/Alert')
);
Vue.component('ald-badge', () =>
  import(/* webpackChunkName: "components/ald/ald-badge" */ 'components/Tesla/Badge')
);
Vue.component('ald-button', () =>
  import(/* webpackChunkName: "components/ald/ald-button" */ 'components/Tesla/Button')
);
Vue.component('ald-button-group', () =>
  import(/* webpackChunkName: "components/ald/ald-button-group" */ 'components/Tesla/ButtonGroup')
);
Vue.component('ald-checkbox', () =>
  import(/* webpackChunkName: "components/ald/ald-checkbox" */ 'components/Tesla/Checkbox')
);
Vue.component('ald-detail', () =>
  import(/* webpackChunkName: "components/ald/ald-detail" */ 'components/Tesla/Detail')
);
Vue.component('ald-detail-layout', () =>
  import(
    /* webpackChunkName: "components/ald/ald-detail-layout" */ 'components/Stratos/DetailLayout'
  )
);
Vue.component('ald-select', () =>
  import(/* webpackChunkName: "components/ald/ald-select" */ 'components/Tesla/Select')
);
Vue.component('ald-custom-select', () =>
  import(
    /* webpackChunkName: "components/ald/ald-custom-select" */ 'components/Stratos/CustomSelect'
  )
);
Vue.component('ald-icon', () =>
  import(/* webpackChunkName: "components/ald/ald-icon" */ 'components/Tesla/Icon')
);
Vue.component('ald-images-drag-sort', () =>
  import(
    /* webpackChunkName: "components/ald/ald-images-drag-sort" */ 'components/Tesla/ImagesDragSort'
  )
);
Vue.component('ald-input', () =>
  import(/* webpackChunkName: "components/ald/ald-input" */ 'components/Tesla/Input')
);
Vue.component('ald-input-stratos', () =>
  import(/* webpackChunkName: "components/ald/ald-input-stratos" */ 'components/Stratos/Input')
);
Vue.component('ald-legal', () =>
  import(/* webpackChunkName: "components/ald/ald-legal" */ 'components/Tesla/Legal')
);
Vue.component('ald-loader', () =>
  import(/* webpackChunkName: "components/ald/ald-loader" */ 'components/Tesla/Loader')
);
Vue.component('ald-loader-layout', () =>
  import(
    /* webpackChunkName: "components/ald/ald-loader-layout" */ 'components/Stratos/LoaderLayout'
  )
);
Vue.component('ald-markdown', () =>
  import(/* webpackChunkName: "components/ald/ald-markdown" */ 'components/Tesla/Markdown')
);
Vue.component('ald-term-kms-matrix', () =>
  import(
    /* webpackChunkName: "components/ald/ald-term-kms-matrix" */ 'components/Tesla/TermKmsMatrix'
  )
);
Vue.component('ald-table-filters', () =>
  import(
    /* webpackChunkName: "components/ald/ald-table-filters" */ 'components/Stratos/TableFilters'
  )
);
Vue.component('ald-text', () =>
  import(/* webpackChunkName: "components/ald/ald-text" */ 'components/Tesla/Text')
);
Vue.component('ald-textarea-stratos', () =>
  import(
    /* webpackChunkName: "components/ald/ald-textarea-stratos" */ 'components/Stratos/Textarea'
  )
);
Vue.component('ald-upload-image-stratos', () =>
  import(
    /* webpackChunkName: "components/ald/ald-upload-image-stratos" */ 'components/Stratos/UploadImage'
  )
);
Vue.component('ald-customer-list-selector', () =>
  import(
    /* webpackChunkName: "components/ald/ald-customer-list-selector'" */ 'components/Stratos/CustomerListSelector'
  )
);
Vue.component('ald-section-filters', () =>
  import(
    /* webpackChunkName: "components/ald/ald-section-filters" */ 'components/Stratos/SectionFilters'
  )
);
Vue.component('ald-card-car-info', () =>
  import(
    /* webpackChunkName: "components/ald/ald-card-car-info'" */ 'components/Stratos/CardCarInfo'
  )
);
Vue.component('ald-calendar', () =>
  import(/* webpackChunkName: "components/ald/ald-calendar'" */ 'components/Stratos/Calendar')
);
Vue.component('ald-grid', () =>
  import(/* webpackChunkName: "components/ald/ald-grid" */ 'components/Stratos/Grid')
);
Vue.component('ald-accessories-selector', () =>
  import(
    /* webpackChunkName: "components/ald/ald-accessories-selector" */ 'components/Stratos/AccessoriesSelector'
  )
);
Vue.component('ald-cms-markdown-editor', () =>
  import(
    /* webpackChunkName: "components/ald/ald-cms-markdown-editor" */ 'components/Stratos/CmsMarkdownEditor'
  )
);
Vue.component('ald-transition', () =>
  import(/* webpackChunkName: "components/ald/ald-transition" */ 'components/Tesla/Transition')
);
Vue.component('ald-tab', () =>
  import(/* webpackChunkName: "components/ald-tab" */ 'components/Tesla/Tabs/Tab')
);
Vue.component('ald-tabs', () =>
  import(/* webpackChunkName: "components/ald-tabs" */ 'components/Tesla/Tabs')
);
Vue.component('ald-pagination', () =>
  import(/* webpackChunkName: "components/ald/ald-pagination" */ 'components/Stratos/Pagination')
);
Vue.component('ald-select-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-select-filter" */ 'components/Tesla/SelectFilter')
);
Vue.component('ald-combo-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-select-filter" */ 'components/Tesla/ComboFilter')
);
Vue.component('ald-input-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-select-filter" */ 'components/Tesla/InputFilter')
);
Vue.component('ald-slide-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-select-filter" */ 'components/Tesla/SlideFilter')
);
Vue.component('ald-tab-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-select-filter" */ 'components/Tesla/TabFilter')
);
Vue.component('ald-switch', () =>
  import(/* webpackChunkName: "components/ald-switch" */ 'components/Tesla/Switch')
);
Vue.component('ald-file-uploader', () =>
  import(
    /* webpackChunkName: "components/Stratos/ald-image-uploader" */ 'components/Stratos/FileUploader'
  )
);
